var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _rect4, _line, _line2, _rect5, _rect6, _rect7, _line3, _line4, _rect8, _rect9, _rect10, _line5, _line6, _rect11, _rect12, _path16, _path17, _path18, _rect13, _path19, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 441 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_710_88)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.055 294.482C444.672 334.175 306.057 384.336 179.915 386.167C53.773 387.998 -14.6386 325.038 37.7286 276.811C90.0957 228.584 419.438 254.788 432.055 294.482Z",
    fill: "#636BC1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.617 76.6304C107.609 79.8463 111.711 81.6969 113.789 81.454C118.997 80.8449 121.972 62.507 119.069 54.7208C116.166 46.9347 96.5824 41.0383 93.6115 55.2735C92.5804 60.2141 94.0681 64.9522 96.6681 69.0078L87.5863 94.1135L103.711 96.3165L103.617 76.6304Z",
    fill: "#FBC5A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.917 48.1769C121.428 51.7641 118.214 54.3101 114.647 54.0152C112.536 54.3633 109.871 54.4665 106.958 54.2656C107.094 55.3574 107.083 56.5751 106.898 57.9276C106.735 59.1218 106.431 60.3704 106.012 61.6232C105.488 60.7938 104.717 60.194 103.867 60.078C101.49 59.7532 99.5692 61.4817 99.2859 63.5569C98.9264 66.1907 100.187 68.3039 102.387 68.7596C99.8636 72.3232 96.7037 74.8347 93.9409 74.4572C88.6932 73.7403 85.9193 66.2169 86.9487 58.6762C86.9848 58.4112 87.026 58.1487 87.072 57.8889C85.1292 58.8649 83.265 60.2374 81.3873 61.6197C77.3978 64.5569 73.3476 67.5388 68.353 66.8565C58.36 65.4912 57.1419 44.8004 71.1035 46.7078C80.5985 48.005 85.0801 50.027 88.8258 52.6233C89.9251 50.4945 91.3924 48.7789 93.0519 47.6676C93.4627 47.3155 94.061 47.0067 94.8138 46.7475C95.2766 46.5709 95.7484 46.4399 96.2261 46.3582C98.7753 45.7981 102.377 45.6494 106.323 46.0489C107.06 46.1235 107.782 46.2144 108.483 46.3199C108.999 42.6219 112.412 40.0368 116.115 40.5427C119.826 41.0497 122.424 44.4676 121.917 48.1769Z",
    fill: "#5B1E13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7976 173.083L111.637 258.646L123.32 322.888H135.047L123.341 173.083H86.7976Z",
    fill: "#D4A181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6343 173.083C77.3675 217.533 76.6839 241.777 76.296 245.815C75.9081 249.854 73.7059 276.9 58.6992 324.244H70.8958C90.7697 278.826 97.7074 251.779 99.9868 245.815C102.266 239.851 108.998 215.607 118.827 173.083H75.6343Z",
    fill: "#D4A181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2644 173.083C92.7256 202.526 103.901 249.523 119.79 314.076H136.941C138.208 247.819 132.819 204.211 123.486 173.083H86.2644Z",
    fill: "#5960AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5476 173.083C77.2451 217.533 72.846 261.324 59.2192 314.768H77.5188C97.4292 270.028 111.7 226.453 121.452 173.083H75.5476Z",
    fill: "#636BC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9609 333.056L57.5564 323.46C57.5961 322.82 58.2206 322.381 58.8518 322.494C64.6903 323.541 72.4392 320.855 72.4392 320.855C80.1715 326.33 91.1401 328.997 95.7905 329.937C96.97 330.175 97.7219 331.368 97.3935 332.525L96.666 335.09H72.4392H58.3069L56.9609 333.056Z",
    fill: "#191847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.703 333.056L121.298 323.46C121.338 322.82 121.963 322.381 122.594 322.494C128.432 323.541 136.181 320.855 136.181 320.855C143.913 326.33 154.882 328.997 159.532 329.937C160.712 330.175 161.464 331.368 161.135 332.525L160.408 335.09H136.181H122.049L120.703 333.056Z",
    fill: "#191847"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.737 175.352L141.796 155.892L135.172 167.356L155.909 179.585C161.108 187.778 164.162 191.318 165.07 190.205C165.835 189.267 165.484 188.238 165.161 187.291C164.909 186.553 164.674 185.864 164.997 185.306C165.734 184.03 169.897 184.761 173.818 185.623C177.74 186.485 176.832 184.558 175.999 183.553C172.293 180.561 167.539 177.827 161.737 175.352ZM44.1964 203.624C46.2593 199.438 53.2843 158.637 53.2843 158.637L67.9948 158.695C67.9948 158.695 54.3702 202.691 53.2843 205.383C51.8736 208.88 54.2698 213.96 55.8946 217.406C56.146 217.939 56.3789 218.432 56.5764 218.875C54.3219 219.884 53.2389 218.665 52.0971 217.379C50.8076 215.926 49.443 214.389 46.2308 215.884C44.9897 216.462 43.8154 217.145 42.668 217.812C38.7048 220.116 35.0641 222.233 30.1113 219.176C29.3261 218.691 28.4656 216.867 30.5446 215.441C35.724 211.888 43.1879 205.671 44.1964 203.624Z",
    fill: "#D4A181"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0894 96.891L101.177 95.8467C111.656 122.034 129.953 145.829 156.067 167.231L136.334 191.212C110.223 160.738 94.1287 129.298 95.0894 96.891Z",
    fill: "#191847"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5542 173.41H122.758C122.758 173.41 103.921 127.596 103.921 95.5734L87.5706 93.1365C74.7207 113.809 71.0918 139.262 68.5542 173.41Z",
    fill: "#DDE3E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9163 196.647C49.8441 129.75 87.2115 93.1365 87.2115 93.1365L87.2245 93.148C87.2267 93.1442 87.2288 93.1403 87.2309 93.1365H88.2982C90.2139 93.2025 94.1339 93.3742 94.1339 93.3742L98.0847 104.668C98.7116 125.323 105.406 187.92 105.406 187.92H69.9269C69.9872 190.79 70.1208 193.7 70.3356 196.647H43.9163Z",
    fill: "#34396F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9328 188.197C69.6497 175.699 70.7581 163.963 72.6073 153.343C73.5744 165.945 75.5957 181.109 79.8173 188.197H69.9328Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7837 166.369L95.3042 158.221V166.369H77.7837Z",
    fill: "white",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.071,
    y: 18.5813,
    width: 194.651,
    height: 275.179,
    rx: 10,
    fill: "#636BC1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 188.458,
    y: 31.8535,
    width: 170.762,
    height: 244.211,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.12,
    y: 15.042,
    width: 73.4364,
    height: 22.1205,
    rx: 5,
    fill: "#34396F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.931 0C258.408 0 253.931 4.47715 253.931 10V15.9268H294.631V10C294.631 4.47715 290.153 0 284.631 0H263.931ZM263.664 6.19379C262.686 6.19379 261.894 6.98608 261.894 7.96343C261.894 8.94078 262.686 9.73307 263.664 9.73307H284.013C284.991 9.73307 285.783 8.94078 285.783 7.96343C285.783 6.98608 284.991 6.19379 284.013 6.19379H263.664Z",
    fill: "#34396F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 206.653,
    y: 88.9822,
    width: 34.3911,
    height: 34.3928,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 12.2043,
    y2: -2,
    transform: "matrix(0.646751 0.762701 -0.716139 0.697958 208.807 106.602)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 28.8598,
    y2: -2,
    transform: "matrix(0.738271 -0.674504 0.621948 0.783059 216.698 115.911)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 97.3302,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 109.718,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 206.653,
    y: 138.532,
    width: 34.3911,
    height: 34.3928,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 12.2043,
    y2: -2,
    transform: "matrix(0.646751 0.762701 -0.716139 0.697958 208.807 156.152)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 28.8598,
    y2: -2,
    transform: "matrix(0.738271 -0.674504 0.621948 0.783059 216.698 165.462)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 146.88,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 159.268,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 206.653,
    y: 188.082,
    width: 34.3911,
    height: 34.3928,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 12.2043,
    y2: -2,
    transform: "matrix(0.646751 0.762701 -0.716139 0.697958 208.807 205.702)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 28.8598,
    y2: -2,
    transform: "matrix(0.738271 -0.674504 0.621948 0.783059 216.698 215.011)",
    stroke: "#636BC1",
    strokeWidth: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 196.43,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 248.622,
    y: 208.818,
    width: 92.9015,
    height: 5.30893,
    rx: 2.65446,
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.361 68.0894H218.725L222.742 56.453H225.912L229.924 68.0894H227.287L224.372 59.1121H224.281L221.361 68.0894ZM221.196 63.5155H227.424V65.4359H221.196V63.5155ZM229.459 58.4814V56.453H239.016V58.4814H235.453V68.0894H233.022V58.4814H229.459ZM240.147 58.4814V56.453H249.703V58.4814H246.141V68.0894H243.709V58.4814H240.147ZM251.277 68.0894V56.453H259.118V58.4814H253.737V61.2541H258.715V63.2825H253.737V66.0609H259.141V68.0894H251.277ZM270.807 56.453V68.0894H268.682L263.62 60.7655H263.534V68.0894H261.074V56.453H263.233L268.256 63.7712H268.358V56.453H270.807ZM276.965 68.0894H272.84V56.453H276.999C278.169 56.453 279.177 56.6859 280.022 57.1519C280.866 57.614 281.516 58.2787 281.97 59.1462C282.429 60.0136 282.658 61.0515 282.658 62.2598C282.658 63.4719 282.429 64.5136 281.97 65.3848C281.516 66.256 280.862 66.9246 280.01 67.3905C279.162 67.8564 278.147 68.0894 276.965 68.0894ZM275.3 65.9814H276.862C277.59 65.9814 278.201 65.8526 278.698 65.595C279.198 65.3337 279.573 64.9303 279.823 64.3848C280.076 63.8356 280.203 63.1272 280.203 62.2598C280.203 61.4 280.076 60.6973 279.823 60.1519C279.573 59.6064 279.2 59.2049 278.703 58.9473C278.207 58.6897 277.595 58.5609 276.868 58.5609H275.3V65.9814ZM285.83 68.0894H283.193L287.21 56.453H290.381L294.392 68.0894H291.756L288.841 59.1121H288.75L285.83 68.0894ZM285.665 63.5155H291.892V65.4359H285.665V63.5155ZM305.526 56.453V68.0894H303.401L298.338 60.7655H298.253V68.0894H295.793V56.453H297.952L302.975 63.7712H303.077V56.453H305.526ZM317.826 60.5269H315.337C315.291 60.2049 315.199 59.9189 315.058 59.6689C314.918 59.4151 314.738 59.1992 314.519 59.0212C314.299 58.8431 314.045 58.7068 313.757 58.6121C313.473 58.5174 313.165 58.47 312.831 58.47C312.229 58.47 311.704 58.6197 311.257 58.9189C310.81 59.2144 310.464 59.6462 310.218 60.2144C309.971 60.7787 309.848 61.4644 309.848 62.2712C309.848 63.1007 309.971 63.7977 310.218 64.3621C310.468 64.9265 310.816 65.3526 311.263 65.6405C311.71 65.9284 312.227 66.0723 312.814 66.0723C313.144 66.0723 313.449 66.0287 313.729 65.9416C314.013 65.8545 314.265 65.7276 314.485 65.5609C314.704 65.3905 314.886 65.1841 315.03 64.9416C315.178 64.6992 315.28 64.4227 315.337 64.1121L317.826 64.1234C317.761 64.6575 317.6 65.1727 317.343 65.6689C317.089 66.1613 316.746 66.6026 316.314 66.9928C315.886 67.3791 315.375 67.6859 314.78 67.9132C314.189 68.1367 313.521 68.2484 312.774 68.2484C311.737 68.2484 310.808 68.0136 309.99 67.5439C309.176 67.0742 308.532 66.3943 308.058 65.5041C307.589 64.614 307.354 63.5363 307.354 62.2712C307.354 61.0022 307.593 59.9227 308.07 59.0325C308.547 58.1424 309.195 57.4644 310.013 56.9984C310.831 56.5287 311.752 56.2939 312.774 56.2939C313.449 56.2939 314.074 56.3886 314.649 56.578C315.229 56.7674 315.742 57.0439 316.189 57.4075C316.636 57.7674 317 58.2087 317.28 58.7314C317.564 59.2541 317.746 59.8526 317.826 60.5269ZM319.59 68.0894V56.453H327.431V58.4814H322.05V61.2541H327.027V63.2825H322.05V66.0609H327.453V68.0894H319.59Z",
    fill: "#636BC1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.194 245.095H245.392C248.153 245.095 250.392 247.334 250.392 250.095V324.153C250.392 326.915 248.153 329.153 245.392 329.153H221.194V245.095Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.453 250.095C165.453 247.334 167.692 245.095 170.453 245.095H245.392C248.153 245.095 250.392 247.334 250.392 250.095V272.525H165.453V250.095Z",
    fill: "#5158A4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 161.029,
    y: 245.095,
    width: 84.9385,
    height: 84.058,
    rx: 5,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.029 250.095C161.029 247.334 163.268 245.095 166.029 245.095H240.968C243.729 245.095 245.968 247.334 245.968 250.095V272.525H161.029V250.095Z",
    fill: "#636BC1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 168.107,
    y: 238.902,
    width: 7.07821,
    height: 15.9268,
    rx: 3.53911,
    fill: "#424242"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184.918,
    y: 238.902,
    width: 7.07821,
    height: 15.9268,
    rx: 3.53911,
    fill: "#424242"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 200.844,
    y: 238.902,
    width: 7.07821,
    height: 15.9268,
    rx: 3.53911,
    fill: "#424242"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 238.902,
    width: 7.07821,
    height: 15.9268,
    rx: 3.53911,
    fill: "#424242"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 231.811,
    y: 238.902,
    width: 7.07821,
    height: 15.9268,
    rx: 3.53911,
    fill: "#424242"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 190.227,
    y: 279.603,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 173.416,
    y: 295.53,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 173.416,
    y: 311.457,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 190.227,
    y: 295.53,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 190.227,
    y: 311.457,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 207.038,
    y: 279.603,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 207.038,
    y: 295.53,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 223.848,
    y: 295.53,
    width: 10.6173,
    height: 10.6179,
    fill: "#CE4E4E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 223.848,
    y: 279.603,
    width: 10.6173,
    height: 10.6179,
    fill: "#CE4E4E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 207.038,
    y: 311.457,
    width: 10.6173,
    height: 10.6179,
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_710_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409.727,
    height: 147.655,
    fill: "white",
    transform: "matrix(0.986615 -0.163066 0.16305 0.986618 12.6824 270.321)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.87c3f88aab91465bc1fa53c274f89645.svg";
export { ForwardRef as ReactComponent };